module.exports = __webpack_public_path__ + "924834cf72c7da1097e011f47a2e6651.svg";